import { ISupplierCompany } from "@evennt-tech/api-v2-core";

interface IGetAddressParams {
  postCode?: boolean;
}

export class SupplierCompanyUtils {
  static getDisplayName(
    company: Pick<ISupplierCompany, "name" | "tradingName">
  ): string {
    return company.tradingName?.trim() || company.name;
  }

  static getAddress(
    company: Pick<
      ISupplierCompany,
      | "country"
      | "state"
      | "city"
      | "addressLine1"
      | "addressLine2"
      | "postCode"
    >,
    { postCode }: IGetAddressParams = { postCode: true }
  ): string {
    const line = [
      company.addressLine1,
      company.addressLine2,
      company.city,
      company.state,
    ];

    if (postCode && company?.postCode) {
      line.push(company?.postCode);
    }

    line.push(company?.country?.name);

    return line.filter(Boolean).join(", ");
  }
}
